export const LOGIN = 'LOGIN';

export const LOGOUT_PROCESS = 'LOGOUT_PROCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';

export const IDENTITY_LOADED = 'IDENTITY_LOADED';
export const IDENTITY_IS_LOADING = 'IDENTITY_IS_LOADING';
export const IDENTITY_IS_NOT_AUTH = 'IDENTITY_IS_NOT_AUTH';